import React from 'react'
import PropTypes from 'prop-types'
import artlookWhite from 'images/artlook-logo-white.svg'
import Translate from './translate'
import ExternalLink from './external-link'
import CommunityImage from './community-image'
import {
  useCommunity,
  isGoogleTranslateEnabled,
  isPortalSignInEnabled,
} from 'utils'
import { get } from 'lodash'
import { Link, withRouter } from 'react-router'
import classnames from 'classnames'
import {
  ARTIST_PORTAL_ROUTE,
  PARTNER_PORTAL_ROUTE,
  SIGN_IN_ROUTE,
} from 'config'

const propTypes = {
  hideLogins: PropTypes.bool,
  showHomeLink: PropTypes.bool,
  location: PropTypes.object,
}

const defaultProps = {
  hideLogins: false,
  showHomeLink: true,
}

function Header({ hideLogins, showHomeLink, location }) {
  const community = useCommunity()
  const isMapHome = location
    ? location.pathname === '/'
    : window.location.pathname === '/'
  const {
    mapLogo,
    secondarySideBySideLogo,
    thirdSideBySideLogo,
    firstSubLogo,
    secondSubLogo,
  } = get(community, 'defaultBranding', {})
  const subLogoRendering =
    !!get(firstSubLogo, 'src') && !!get(secondSubLogo, 'src')
  const showCommunityLogo = !!get(mapLogo, 'src')
  const showPoweredBy = showCommunityLogo && !subLogoRendering
  const showHomeRegistrationLink = community?.showHomeRegistrationLink || false
  const showHomeApplicationLink =
    community?.teachingArtist?.showHomeApplicationLink || false
  const showPartnerHomeApplicationLink =
    community?.showPartnerHomeApplicationLink || false

  const isSacramento = community?.subdomain === 'sacramento'

  return (
    <div>
      {community && (
        <a href="#content" id="skip-nav-link">
          Skip to Main Content
        </a>
      )}
      <header className="navigation">
        <div className="left-nav">
          {showCommunityLogo ? (
            <div>
              {!subLogoRendering ? (
                <div
                  className={classnames('map-logo', {
                    'side-by-side': secondarySideBySideLogo,
                  })}
                >
                  <CommunityImage className="logo" image={mapLogo} />
                  {secondarySideBySideLogo && (
                    <div className="second-logo">
                      <CommunityImage image={secondarySideBySideLogo} />
                      {isSacramento && (
                        <div className="powered-by">
                          <div className="powered-by-inner">
                            <ExternalLink href="https://artlookmap.com">
                              <p>Powered by</p>
                              <img src={artlookWhite} alt="Artlook" />
                            </ExternalLink>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {thirdSideBySideLogo && (
                    <div className="third-logo">
                      <CommunityImage image={thirdSideBySideLogo} />
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className="powered-by">
                    <div className="powered-by-inner">
                      <ExternalLink href="https://artlookmap.com">
                        <p>Powered by</p>
                        <img src={artlookWhite} alt="Artlook" />
                      </ExternalLink>
                    </div>
                  </div>
                  <CommunityImage className="sub-logo" image={firstSubLogo} />
                </div>
              )}
              <span className="visually-hidden">{community.name}</span>
            </div>
          ) : (
            <a href="/">
              <img className="logo" src={artlookWhite} alt="Artlook" />
            </a>
          )}
          {showPoweredBy && !isSacramento && (
            <div className="powered-by">
              <div className="powered-by-inner">
                <ExternalLink href="https://artlookmap.com">
                  <p>Powered by</p>
                  <img src={artlookWhite} alt="Artlook" />
                </ExternalLink>
              </div>
            </div>
          )}
        </div>
        <div className="right-nav">
          <nav aria-label="Primary navigation">
            <ul>
              {isGoogleTranslateEnabled(community) && (
                <li>
                  <Translate />
                </li>
              )}
              {showHomeLink && (
                <li>
                  <Link to="/" className="button-primary">
                    Home
                  </Link>
                </li>
              )}
              {showHomeRegistrationLink && isMapHome && (
                <React.Fragment>
                  <li>
                    <ExternalLink
                      href={`${ARTIST_PORTAL_ROUTE}/register`}
                      className="button-primary"
                    >
                      Teaching Artist Registration
                    </ExternalLink>
                  </li>
                  <li>
                    <ExternalLink
                      href={`${SIGN_IN_ROUTE}/register`}
                      className="button-primary"
                    >
                      Organization Registration
                    </ExternalLink>
                  </li>
                </React.Fragment>
              )}
              {showPartnerHomeApplicationLink && isMapHome && (
                <li>
                  <ExternalLink
                    href={`${PARTNER_PORTAL_ROUTE}/application`}
                    className="button-primary"
                  >
                    Arts Organization Application
                  </ExternalLink>
                </li>
              )}
              {showHomeApplicationLink && isMapHome && (
                <li>
                  <ExternalLink
                    href={`${ARTIST_PORTAL_ROUTE}/application`}
                    className="button-primary"
                  >
                    Teaching Artist Application
                  </ExternalLink>
                </li>
              )}
              {community && !hideLogins && (
                <React.Fragment>
                  {isPortalSignInEnabled(community) && (
                    <li>
                      <ExternalLink
                        href={process.env.SIGN_IN_URL}
                        className="button-primary"
                      >
                        Sign In
                      </ExternalLink>
                    </li>
                  )}
                </React.Fragment>
              )}
            </ul>
          </nav>
          {secondSubLogo && (
            <CommunityImage
              className="right-nav sub-logo"
              image={secondSubLogo}
            />
          )}
        </div>
      </header>
    </div>
  )
}

Header.propTypes = propTypes
Header.defaultProps = defaultProps

export default withRouter(Header)
